module.exports = __webpack_public_path__ + "static/media/warning-24.a86f3a97.svg";